window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.identityVerificationBox = window.locales.am.identityVerificationBox || {};window.locales.am.identityVerificationBox = {...window.locales.am.identityVerificationBox, ...{
    "subtitle": "ማንነት",
    "title": "ማረጋገጫ",
    "content": "ለመቀጠል የማንነት ማረጋገጫ ሂደትን ማጠናቀቅ ያስፈልግዎታል።",
    "mobileTitle": "የማንነት ማረጋገጫ",
    "buttonVerifyIdentity": "ማንነትን ያረጋግጡ",
    "buttonNextSteps": "ቀጣይ ደረጃዎች"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.identityVerificationBox = window.locales.ar.identityVerificationBox || {};window.locales.ar.identityVerificationBox = {...window.locales.ar.identityVerificationBox, ...{
    "subtitle": "الهوية",
    "title": "التحقق",
    "content": "من أجل المتابعة، ستحتاج إلى إكمال عملية التحقق من الهوية.",
    "mobileTitle": "التحقق من الهوية",
    "buttonVerifyIdentity": "التحقق من الهوية",
    "buttonNextSteps": "الخطوات التالية"
}
};window.locales.en = window.locales.en || {};window.locales.en.identityVerificationBox = window.locales.en.identityVerificationBox || {};window.locales.en.identityVerificationBox = {...window.locales.en.identityVerificationBox, ...{
    "subtitle": "Identity",
    "title": "Verification",
    "content": "In order to continue, you will need to complete an identity verification process.",
    "mobileTitle": "Identity Verification",
    "buttonVerifyIdentity": "Verify Identity",
    "buttonNextSteps": "Next Steps"
}
};window.locales.es = window.locales.es || {};window.locales.es.identityVerificationBox = window.locales.es.identityVerificationBox || {};window.locales.es.identityVerificationBox = {...window.locales.es.identityVerificationBox, ...{
    "subtitle": "Identidad",
    "title": "Verificación",
    "content": "Para continuar, deberá completar un proceso de verificación de identidad.",
    "mobileTitle": "Verificación de Identidad",
    "buttonVerifyIdentity": "Verificar Identidad",
    "buttonNextSteps": "Próximos Pasos"
}
};window.locales.it = window.locales.it || {};window.locales.it.identityVerificationBox = window.locales.it.identityVerificationBox || {};window.locales.it.identityVerificationBox = {...window.locales.it.identityVerificationBox, ...{
    "subtitle": "Identità",
    "title": "Verifica",
    "content": "Per continuare, dovrai completare un processo di verifica dell'identità.",
    "mobileTitle": "Verifica dell'Identità",
    "buttonVerifyIdentity": "Verifica Identità",
    "buttonNextSteps": "Prossimi Passi"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.identityVerificationBox = window.locales.zh.identityVerificationBox || {};window.locales.zh.identityVerificationBox = {...window.locales.zh.identityVerificationBox, ...{
    "subtitle": "身份",
    "title": "验证",
    "content": "为了继续，您需要完成身份验证流程。",
    "mobileTitle": "身份验证",
    "buttonVerifyIdentity": "验证身份",
    "buttonNextSteps": "下一步"
}
};